const e = "Dialogfenster", t = "Schließen", l = {
  title: e,
  close: t
};
export {
  t as close,
  l as default,
  e as title
};
